import React from 'react';
import update from 'immutability-helper';
import cn from 'classnames';
import createClass from 'create-react-class';
import {animationMixin} from './animation-mixin';

/******************************************** HELPERS *********************************************/
function noop() {}

/********************************************* EXPORT *********************************************/
const ToastMessageRaw = {
    displayName: `ToastMessage`,

    /**
     * Add default toast message props
     */
    getDefaultProps() {
        return {
            className: `toast`,
            iconClassNames: {
                error: `toast-error`,
                info: `toast-info`,
                success: `toast-success`,
                warning: `toast-warning`,
            },
            titleClassName: `toast-title`,
            messageClassName: `toast-message`,
            tapToDismiss: true,
            closeButton: false,
        };
    },

    handleOnClick(event) {
        this.props.handleOnClick(event);
        if (this.props.tapToDismiss) {
            this.hideToast(true);
        }
    },

    handleCloseButtonClick(event) {
        event.stopPropagation();
        this.hideToast(true);
    },

    handleRemove() {
        this.props.handleRemove(this.props.toastId);
    },

    renderCloseButton() {
        return this.props.closeButton ? (
            <button
                className={cn(`toast-close-button`)}
                onClick={this.handleCloseButtonClick}
                dangerouslySetInnerHTML={{__html: `&times;`}}
            />
        ) : (
            false
        );
    },

    renderTitleElement() {
        return this.props.title ? (
            <div className={this.props.titleClassName}>{this.props.title}</div>
        ) : (
            false
        );
    },

    renderMessageElement() {
        return this.props.message ? (
            <div className={this.props.messageClassName}>{this.props.message}</div>
        ) : (
            false
        );
    },

    render() {
        const iconClassName =
            this.props.iconClassName || this.props.iconClassNames[this.props.type];

        return (
            <div
                className={cn(this.props.className, iconClassName)}
                style={this.props.style}
                onClick={this.handleOnClick}
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                {this.renderCloseButton()}
                {this.renderTitleElement()}
                {this.renderMessageElement()}
            </div>
        );
    },
};

export const animation = createClass(
    update(ToastMessageRaw, {
        displayName: {$set: `ToastMessage.animation`},
        mixins: {$set: [animationMixin]},
    })
);

/*
 * Assign default noop functions
 */
(ToastMessageRaw as any).handleMouseEnter = noop;
(ToastMessageRaw as any).handleMouseLeave = noop;
(ToastMessageRaw as any).hideToast = noop;

const ToastMessage = createClass(ToastMessageRaw);
ToastMessage.animation = animation;

export default ToastMessage;
